import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './css/NewsDetail.css';
import { NewsDetailItem, NewsListItem, NewsApiResponse } from '../components/NewsData';

const NewsDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [article, setArticle] = useState<NewsDetailItem | null>(null);
    const [recentNews, setRecentNews] = useState<NewsListItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id) return;
        setLoading(true);
        setError(null);
        setArticle(null);

        Promise.all([
            fetch(`/news.php?id=${id}`).then(res => {
                if (!res.ok) throw new Error('Not found');
                return res.json() as Promise<NewsDetailItem>;
            }),
            fetch(`/news.php?page=1&page_size=10`).then(res =>
                res.json() as Promise<NewsApiResponse>
            ),
        ])
            .then(([articleData, listData]) => {
                setArticle(articleData);
                setRecentNews(
                    listData.results.filter(n => n.id !== articleData.id).slice(0, 5)
                );
            })
            .catch(() => setError('Мэдээ татахад алдаа гарлаа.'))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return <div className="news-detail-container"><p>Уншиж байна...</p></div>;
    }
    if (error || !article) {
        return <div className="news-detail-container"><p>Мэдээ олдсонгүй.</p></div>;
    }

    const getYouTubeEmbedUrl = (url: string) => {
        const match = url.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? `https://www.youtube.com/embed/${match[1]}` : null;
    };

    const renderMedia = () => {
        if (article.video_file) {
            return (
                <video controls className="news-detail-video">
                    <source src={article.video_file} type="video/mp4" />
                </video>
            );
        }
        if (article.video_url) {
            const youtubeEmbed = getYouTubeEmbedUrl(article.video_url);
            if (youtubeEmbed) {
                return (
                    <iframe
                        className="news-detail-video"
                        src={youtubeEmbed}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={article.title}
                    />
                );
            }
            return (
                <a href={article.video_url} target="_blank" rel="noopener noreferrer" className="news-detail-video-link">
                    Видео үзэх
                </a>
            );
        }
        return <img src={article.cover} alt={article.title} />;
    };

    return (
        <div className="news-detail-container">
            <div className="news-detail-main">
                <h2>{article.title}</h2>
                {renderMedia()}
                <div
                    className="news-content"
                    dangerouslySetInnerHTML={{ __html: article.body || article.summary }}
                />
                {article.images.map((img, i) => (
                    <img key={img.id} src={img.image} alt={img.caption || `${article.title} ${i + 1}`} />
                ))}
            </div>
            <div className="news-detail-sidebar">
                <h3>Шинэ мэдээ</h3>
                <ul>
                    {recentNews.map(item => (
                        <li key={item.id}>
                            <Link to={`/news/${item.id}`}>
                                <img src={item.cover} alt={item.title} />
                                <span>{item.title}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default NewsDetail;
